module.exports = __webpack_public_path__ + "img/youchuo-yiyuyue.2ffc2635.png";